export default __webpack_public_path__ + "static/media/08.14.5964dced.jpg";